import styled from "@emotion/styled";
import Link from "next/link";
import { trackFooterLinkClicked } from "reusable/ChargeGTM";
import colors from "theme/colors";
import { NewText, extractProperty } from "ui";
import { getNonUmbracoURL } from "utils/utils";

const StyledLinksWrapper = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  padding: 0px;
${(props) => props.theme.breakpoints.up("md")} {
      grid-template-columns: repeat(4, 1fr);
      gap: 0px;
  }
`
const StyledLinkItemMobile = styled.li<{ isFirstLink: boolean }>`
   color: white;
   height: 60px;
   display: flex;
   align-items: center;

  ${(props) => props.theme.breakpoints.down("md")} {
     border-bottom: 1px solid rgba(130, 136, 148, 0.7);
     ${(props) => props.isFirstLink && "border-top: 1px solid rgba(130, 136, 148, 0.7);"}
  }
${(props) => props.theme.breakpoints.up("md")} {
       height: 40px;
  }
`
const StyledSpan = styled.div`
a {
text-decoration: none;
}
font-size: 14px;
font-weight: 400;
line-height: 24px;
text-align: left;
padding-left: 4px;
a {
text-decoration: none;
}
`
interface FooterLinksContainerProps {
    links: any[]
}
function FooterLinksContainer({ links }: FooterLinksContainerProps) {
    return (
        <StyledLinksWrapper>
            {links.map((link, index) => {
                const title = extractProperty(link, "title")
                const mainCategoryLink = extractProperty(
                    link,
                    "mainCategoryLink",
                )
                const { url, target } = mainCategoryLink[0]
                return (
                    <StyledLinkItemMobile
                        key={index}
                        isFirstLink={index === 0 || index === 1}
                    >
                        <StyledSpan>
                            {mainCategoryLink && (
                                <Link
                                    href={
                                        getNonUmbracoURL(url || "#")
                                    }
                                    target={target || "_self"}
                                    onClick={() => {
                                        trackFooterLinkClicked(title)
                                    }}
                                >
                                    <NewText
                                        desktopFontSize={16}
                                        component="p"
                                        desktopLineHeight="150%"
                                        desktopFontWeight="500"
                                        mobileFontWeight={400}
                                        color={colors.white}
                                    >
                                        {title}
                                    </NewText>
                                </Link>
                            )}
                        </StyledSpan>
                    </StyledLinkItemMobile>
                )
            })}
        </StyledLinksWrapper>
    );
}
export default FooterLinksContainer;
